import React from 'react';
import styled from 'styled-components';
import WalletPanel from '../../components/profile/WalletPanel';

const PageContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 80px);
  padding: 16px 0 100px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  
  @media (max-width: 480px) {
    padding: 12px 0 100px 0;
  }
  
  /* Ensure child components are full width */
  & > * {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
    
    @media (max-width: 480px) {
      padding-left: 12px;
      padding-right: 12px;
    }
  }
`;

const ProfilePWA: React.FC = () => {
  return (
    <PageContainer>
      <WalletPanel />
    </PageContainer>
  );
};

export default ProfilePWA;

